import { useEffect, useState } from "react";
import { cn } from "@/lib/cn.ts";
import { ProductStage } from "@/product-stage/ProductStage.tsx";
import { WhyGates } from "@/landing/WhyGates.tsx";
import { WhyMatterline } from "@/landing/WhyMatterline.tsx";
import { WhyNow } from "@/landing/WhyNow.tsx";
import { AgentComparison } from "@/landing/AgentComparison.tsx";
import { TrialApplicationCta } from "@/landing/TrialApplicationCta.tsx";
import { InternalRegistrationCta } from "@/landing/InternalRegistrationCta.tsx";
import { productOnboardingMode, type ProductOnboardingMode } from "@/deployment-mode.ts";

const LOGO = `${import.meta.env.BASE_URL}matterline.svg`;

export function LandingPage({ mode = productOnboardingMode() }: { mode?: ProductOnboardingMode }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="landing">
      <header className={cn("site-header", scrolled && "is-scrolled")}>
        <a className="site-brand" href="#top">
          <img src={LOGO} alt="" />
          Matterline
        </a>
        <nav className="site-nav" aria-label="页面">
          <a href="#why">三道门槛</a>
          <a href="#why-now">为什么是现在</a>
          <a href="#why-matterline">Matterline 的答案</a>
          <a href="#comparison">方案对比</a>
        </nav>
        <a
          className="site-cta"
          href={mode === "internal_self_registration" ? "#download" : "#why-matterline"}
        >
          {mode === "internal_self_registration" ? "注册下载" : "查看方案"}
        </a>
      </header>

      <main id="top">
        <section className="hero">
          <div className="hero-atmosphere" aria-hidden="true">
            <div className="hero-atmosphere-glow" />
            <div className="hero-atmosphere-grid" />
            <div className="hero-atmosphere-vignette" />
          </div>
          <div className="hero-copy">
            <h1>
              <span className="hero-brand">Matterline</span>
              <span className="hero-kicker">
                企业<span className="hero-mark">私有智能</span>工作台
              </span>
              <span className="hero-claim">
                把企业<span className="hero-mark">智能</span>，
                <br className="hero-claim-break" />
                留在企业<span className="hero-mark">内部</span>。
              </span>
            </h1>
            <p className="lede">
              <span>
                本地模型、企业数据和专家智能体，
                <br className="lede-break" />
                在同一张工作台里协作。
              </span>
              <span>
                面向企业内网的<span className="hero-mark">私有部署方案</span>。
              </span>
            </p>
          </div>
          <ProductStage />
        </section>

        <WhyGates />

        <WhyNow />

        <WhyMatterline />

        <AgentComparison />

        {mode === "internal_self_registration" ? (
          <InternalRegistrationCta />
        ) : (
          <TrialApplicationCta />
        )}
      </main>

      <footer className="site-footer">Matterline · 企业私有智能工作台</footer>
    </div>
  );
}
